import { createFileRoute } from "@tanstack/react-router"
import ProgressPageContent from "@/pages/home/progress"

export const Route = createFileRoute("/home/voortgang/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <ProgressPageContent />
}
